import { Route, Routes } from "react-router-dom";
import OnboardingDocumentation from "../../pages/dashboard/OnboardingDocumentation";
import Introduction from "../../pages/dashboard/Documentation/Introduction";
import AssetInventory from "../../pages/dashboard/Documentation/AssetInventory";
import Scoping from "../../pages/dashboard/Documentation/Scoping";
import EndpointDiscovery from "../../pages/dashboard/Documentation/EndpointDiscovery";
import CredentialVault from "../../pages/dashboard/Documentation/CredentialVault";
import ProgramEngineering from "../../pages/dashboard/Documentation/ProgramEngineering";
import ScheduledRuns from "../../pages/dashboard/Documentation/ScheduledRuns";
import SnapshotVerification from "../../pages/dashboard/Documentation/SnapshotVerification";

const OnboardingDocumentationRoutes = () => {
  return (
    <Routes>
      <Route element={<OnboardingDocumentation />}>
        <Route index element={<Introduction />} />
        <Route path="asset-inventory" element={<AssetInventory />} />
        <Route path="scoping" element={<Scoping />} />
        <Route path="endpoint-discovery" element={<EndpointDiscovery />} />
        <Route path="credential-vault" element={<CredentialVault />} />
        <Route path="program-engineering" element={<ProgramEngineering />} />
        <Route path="scheduled-runs" element={<ScheduledRuns />} />
        <Route path="snapshot-verification" element={<SnapshotVerification />} />
      </Route>
    </Routes>
  );
};

export default OnboardingDocumentationRoutes;
